export async function convertImageToBase64(url: string): Promise<string> {
    try {
        const res = await fetch(url);
        const blob = await res.blob();
        return new Promise((resolve) => {
            const reader = new FileReader();
            reader.readAsDataURL(blob);
            reader.onloadend = () => resolve(typeof reader.result === 'string' ? reader.result : '');
            reader.onerror = () => resolve('');
        });
    } catch (err) {
        throw new Error(`Error while converting image to base64: ${JSON.stringify(err)}`);
    }
}
